"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFieldMapCell = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledFieldMapCell = (0, styled_components_1.default)(function (_a) {
    var customWidth = _a.customWidth, restProps = __rest(_a, ["customWidth"]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, restProps)));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: ", ";\n  flex: ", ";\n  width: ", ";\n\n  & .components-base-control {\n    flex: 1;\n  }\n"], ["\n  align-items: center;\n  display: ", ";\n  flex: ", ";\n  width: ", ";\n\n  & .components-base-control {\n    flex: 1;\n  }\n"])), function (props) { return (props.customWidth ? 'inline-flex' : undefined); }, function (props) { return (props.customWidth ? undefined : '1'); }, function (props) { var _a; return (_a = props.customWidth) !== null && _a !== void 0 ? _a : undefined; });
var templateObject_1;
